import { render, staticRenderFns } from "./Agradecimento.vue?vue&type=template&id=66c9b2da&scoped=true&"
import script from "./Agradecimento.vue?vue&type=script&lang=js&"
export * from "./Agradecimento.vue?vue&type=script&lang=js&"
import style0 from "./Agradecimento.vue?vue&type=style&index=0&id=66c9b2da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c9b2da",
  null
  
)

export default component.exports